<template>
  <div :class="`l-menu ${ isGlobalMenu ? 'is-open' : 'is-close' }`" @click="toggleGlobalMenu(false)">
    <div class="l-menu__wrapper">
      <h1 class="l-menu__siteName">
        <a :href="`/s/companies/${ currentCompanyUuid }/dashboards`">
          <KkIcon class="logoIcon" :name="logoName" />
        </a>
      </h1>
      <nav class="l-menu__inner">
        <ul class="l-menu__items">
          <li class="l-menu__item" @click="toggleMenu('')">
            <router-link
              class="l-menu__name"
              :to="{ name: 'CompaniesDashboards', params: { company_uuid: currentCompanyUuid }}"
              :class="{ 'is-current': currentMenu === 'dashboards' }"
            >
              <span><Icon name="iconHome" /></span>
              {{ $t('layouts.sideMenu.home.name') }}
            </router-link>
          </li>
          <li v-if="providedFeaturesBenefit && showOnlyOwnerAuthority && useServiceName === 'kcom'" class="l-menu__item" @click="toggleMenu('benefits')">
            <router-link
              class="l-menu__name"
              :to="{ name: 'CompaniesBenefitsIndex', params: { company_uuid: currentCompanyUuid }}"
              :class="{ 'is-current': currentMenu === 'benefits' }"
            >
              <span><Icon name="iconBenefit" /></span>
              {{ $t('layouts.sideMenu.benefits.name') }}
            </router-link>
          </li>
          <li class="l-menu__item">
            <div class="l-menu__name" @click="toggleMenu('locationStore')">
              <span><Icon name="iconStores" /></span>
              {{ $t('layouts.sideMenu.locationStore.name') }}
              <div
                v-show="unreadGmbLocationSyncLogsCount > 0 && !isRettyPlan"
                class="l-menu__badge"
                v-text="unreadGmbLocationSyncLogsCount > 999 ? '999+' : unreadGmbLocationSyncLogsCount"
              />
            </div>
            <ul class="l-menu__subMenu">
              <li ref="locationStore" @mouseenter="toggleHoverMenu('locationStore')" @mouseleave="toggleHoverMenu('locationStore')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesLocationStores', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('location/stores') }"
                >
                  {{ $t('layouts.sideMenu.locationStore.stores.name') }}
                  <div
                    v-show="unreadGmbLocationSyncLogsCount > 0 && !isRettyPlan"
                    class="l-menu__badge"
                    v-text="unreadGmbLocationSyncLogsCount > 999 ? '999+' : unreadGmbLocationSyncLogsCount"
                  />
                </router-link>
              </li>
              <li v-if="showMoreThanOperatorAuthority && providedFeaturesMediaLibrary">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesMediaLibraries', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('media_libraries') && !currentMenu.includes('stores') }"
                >
                  {{ $t('layouts.sideMenu.locationStore.mediaLibraries') }}
                </router-link>
              </li>
              <li v-if="canHaveFoodMenus && providedFeaturesFoodMenu && showOnlyOwnerAuthority">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesFoodMenusIndex', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('food_menus') }"
                >
                  {{ $t('layouts.sideMenu.locationStore.foodMenus') }}
                </router-link>
              </li>
              <li v-if="providedFeaturesServicePattern && canModifyServiceList && showOnlyOwnerAuthority">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesServices', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('services') }"
                >
                  {{ $t('layouts.sideMenu.locationStore.services') }}
                </router-link>
              </li>
              <li v-if="hasAvailableProduct && providedFeaturesProduct" ref="products" @mouseenter="toggleHoverMenu('products')" @mouseleave="toggleHoverMenu('products')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesProducts', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('products') && !currentMenu.includes('location/stores') }"
                >
                  {{ $t('layouts.sideMenu.locationStore.products.name') }}
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="hasMonitoringFeatures" class="l-menu__item">
            <div class="l-menu__name" @click="toggleMenu('monitoring')">
              <span><Icon name="iconReview" /></span>
              {{ $t('layouts.sideMenu.monitoring.name') }}
              <div
                v-show="unreadObservationCount > 0"
                class="l-menu__badge"
                v-text="unreadObservationCount > 999 ? '999+' : unreadObservationCount"
              />
            </div>
            <ul class="l-menu__subMenu">
              <li v-if="providedFeaturesReview">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesReviews', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu === 'reviews' }"
                >
                  {{ $t('layouts.sideMenu.monitoring.reviews') }}
                  <div
                    v-show="unreadReviewsCount > 0"
                    class="l-menu__badge"
                    v-text="unreadReviewsCount > 999 ? '999+' : unreadReviewsCount"
                  />
                </router-link>
              </li>
              <li v-if="providedFeaturesPhoto">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesPhotos', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu === 'photos' }"
                >
                  {{ $t('layouts.sideMenu.monitoring.photos') }}
                  <div
                    v-show="unreadPhotosCount > 0"
                    class="l-menu__badge"
                    v-text="unreadPhotosCount > 999 ? '999+' : unreadPhotosCount"
                  />
                </router-link>
              </li>
              <li v-if="providedFeaturesSurvey">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesCustomSurveyAnswers', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('custom_surveys/answers') }"
                >
                  {{ $t('layouts.sideMenu.monitoring.surveys') }}
                  <div
                    v-show="unreadSurveyAnswersCount > 0"
                    class="l-menu__badge"
                    v-text="unreadSurveyAnswersCount > 999 ? '999+' : unreadSurveyAnswersCount"
                  />
                </router-link>
              </li>
              <li v-if="providedFeaturesTestimonial">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesTestimonialIndex', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu.includes('testimonials') }"
                >
                  {{ $t('layouts.sideMenu.monitoring.testimonials.complaint') }}
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="hasOperationFeatures" class="l-menu__item">
            <div class="l-menu__name" @click="toggleMenu('operation')">
              <span><Icon name="iconUnion" /></span>
              {{ $t('layouts.sideMenu.operation.name') }}
            </div>
            <ul class="l-menu__subMenu">
              <li v-if="providedFeaturesPost" ref="gmbPosts" @mouseenter="toggleHoverMenu('gmbPosts')" @mouseleave="toggleHoverMenu('gmbPosts')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesStorePostsIndex', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('posts') && !currentMenu.includes('sns')}"
                >
                  {{ $t('layouts.sideMenu.operation.gmbPosts.name') }}
                </router-link>
              </li>
            </ul>
            <ul class="l-menu__subMenu">
              <li v-if="providedFeaturesSns" ref="snsPosts" @mouseenter="toggleHoverMenu('snsPosts')" @mouseleave="toggleHoverMenu('snsPosts')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesStoreSnsPostsIndex', params: { company_uuid: currentCompanyUuid }}"
                  :class="{ 'is-current': currentMenu.includes('sns/posts') }"
                >
                  {{ $t('layouts.sideMenu.operation.snsPosts.name') }}
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="hasAnalysisFeatures" class="l-menu__item">
            <div class="l-menu__name" @click="toggleMenu('analysis')">
              <span><Icon name="iconAnalysis" /></span>
              {{ $t('layouts.sideMenu.analysis.name') }}
            </div>
            <ul class="l-menu__subMenu">
              <li v-if="providedFeaturesAnalysisInsight" ref="insight" @mouseenter="toggleHoverMenu('insight')" @mouseleave="toggleHoverMenu('insight')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisInsight', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu === 'analysis/insight' }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.insight')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisReview" ref="reviews" @mouseenter="toggleHoverMenu('reviews')" @mouseleave="toggleHoverMenu('reviews')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisReviews', params: { company_uuid: currentCompanyUuid }, query: { fields: 'store_id' } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/reviews') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.review')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisScatter">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisScatter', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/scatter') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.scatter')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisSearchKeywordImpression">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisSearchQueries', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/search_queries') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.searchQueries')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisRanking">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisRanking', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/ranking') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.ranking')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisQsca">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisQscas', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/qscas') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.qscas')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisVisitor" ref="visitors" @mouseenter="toggleHoverMenu('visitors')" @mouseleave="toggleHoverMenu('visitors')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisVisitors', params: { company_uuid: currentCompanyUuid }, query: { fields: 'store_id' } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/visitors') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.visitor')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisKeyword" ref="keywordAnalysis" @mouseenter="toggleHoverMenu('keywordAnalysis')" @mouseleave="toggleHoverMenu('keywordAnalysis')">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisKeywords', params: { company_uuid: currentCompanyUuid }, query: { tab: 'store' } }"
                  :class="{ 'is-current': currentMenu.includes('analysis/keywords') }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.keyword')" />
                </router-link>
              </li>
              <li v-if="providedFeaturesAnalysisSurvey">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesAnalysisSurveys', params: { company_uuid: currentCompanyUuid }, query: { fields: 'store_id' } }"
                  :class="{ 'is-current': currentMenu === 'analysis/surveys' }"
                >
                  <div v-text="$t('layouts.sideMenu.analysis.survey')" />
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="hasCompetitorFeatures" class="l-menu__item">
            <div
              class="l-menu__name"
              @click="toggleMenu('competitors')"
            >
              <span><Icon name="iconCompetitor" /></span>
              {{ $t('layouts.sideMenu.competitors.name') }}
            </div>
            <ul class="l-menu__subMenu">
              <template v-if="providedFeaturesCompetitor">
                <li v-if="providedFeaturesReview">
                  <router-link
                    class="l-menu__name l-menu__name--competitors"
                    :to="{ name: 'CompaniesCompetitorsReviews', params: { company_uuid: currentCompanyUuid }}"
                    :class="{ 'is-current': currentMenu === 'competitors/reviews' }"
                  >
                    {{ $t('layouts.sideMenu.competitors.reviews') }}
                  </router-link>
                </li>
                <li v-if="providedFeaturesPhoto">
                  <router-link
                    class="l-menu__name l-menu__name--competitors"
                    :to="{ name: 'CompaniesCompetitorsPhotos', params: { company_uuid: currentCompanyUuid }}"
                    :class="{ 'is-current': currentMenu === 'competitors/photos' }"
                  >
                    {{ $t('layouts.sideMenu.competitors.photos') }}
                  </router-link>
                </li>
                <li v-if="providedFeaturesAnalysisReview">
                  <router-link
                    class="l-menu__name l-menu__name--competitors"
                    :to="{ name: 'CompaniesAnalysisReviews', params: { company_uuid: currentCompanyUuid }, query: { fields: 'store_id', mode: 'competitor' } }"
                  >
                    {{ $t('layouts.sideMenu.competitors.analysisReviews') }}
                  </router-link>
                </li>
                <li v-if="providedFeaturesAnalysisKeyword">
                  <router-link
                    class="l-menu__name l-menu__name--competitors"
                    :to="{ name: 'CompaniesAnalysisKeywords', params: { company_uuid: currentCompanyUuid }, query: { tab: 'competitor' } }"
                  >
                    {{ $t('layouts.sideMenu.competitors.keywords') }}
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li v-if="hasVisitorFeatures && showMoreThanOperatorAuthority" class="l-menu__item">
            <div class="l-menu__name" @click="toggleMenu('visitorStore')">
              <span><Icon name="iconStores" /></span>
              {{ $t('layouts.sideMenu.visitorStore.name') }}
            </div>
            <ul class="l-menu__subMenu">
              <li v-if="providedFeaturesVisitor">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesVisitorStores', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu === 'visitor/stores' }"
                >
                  {{ $t('layouts.sideMenu.visitorStore.store') }}
                </router-link>
              </li>
              <li v-if="providedFeaturesSurvey && showMoreThanEditorAuthority">
                <router-link
                  class="l-menu__name"
                  :to="{ name: 'CompaniesSurveys', params: { company_uuid: currentCompanyUuid } }"
                  :class="{ 'is-current': currentMenu === 'surveys' }"
                >
                  {{ $t('layouts.sideMenu.visitorStore.survey') }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
    <HoverMenu
      v-show="hoverMenu.locationStore"
      :menu-list="locationStore"
      :target="'locationStore'"
      :top="hoverMenuPosition('locationStore')"
    />
    <HoverMenu
      v-show="hoverMenu.products && showMoreThanEditorAuthority"
      :menu-list="products"
      :target="'products'"
      :top="hoverMenuPosition('products')"
    />
    <HoverMenu
      v-show="hoverMenu.gmbPosts"
      :menu-list="gmbPosts"
      :target="'gmbPosts'"
      :top="hoverMenuPosition('gmbPosts')"
    />
    <HoverMenu
      v-show="hoverMenu.snsPosts"
      :menu-list="snsPosts"
      :target="'snsPosts'"
      :top="hoverMenuPosition('snsPosts')"
    />
    <HoverMenu
      v-if="!isRettyPlan"
      v-show="hoverMenu.insight"
      :menu-list="gmbInsightDataTypes"
      :target="'insight'"
      :top="hoverMenuPosition('insight')"
    />
    <HoverMenu
      v-show="hoverMenu.reviews"
      :menu-list="analysisTypes"
      :target="'reviews'"
      :top="hoverMenuPosition('reviews')"
    />
    <HoverMenu
      v-show="hoverMenu.visitors"
      :menu-list="visitorsTypes"
      :target="'visitors'"
      :top="hoverMenuPosition('visitors')"
    />
    <HoverMenu
      v-show="hoverMenu.keywordAnalysis && providedFeaturesCompetitor"
      :menu-list="keywordAnalysisTypes"
      :target="'keywordAnalysis'"
      :top="hoverMenuPosition('keywordAnalysis')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Icon from './Icon.vue'
import { KkIcon } from '../components/base'
import HoverMenu from './HoverMenu.vue'
import { reviewDataTypes, gmbInsightDataTypes, visitorsTypes, keywordAnalysisTypes } from '../modules/analysis'
import { camelCase } from '../modules/string_converter'
import { mapState as piniaMapState, mapActions as piniaMapActions } from 'pinia'
import { useRpaErrorLogsStore } from '../new_stores/rpaErrorLogs'

export default {
  name: 'Menu',
  components: {
    Icon,
    HoverMenu,
    KkIcon
  },
  props: {
    showMoreThanEditorAuthority: {
      required: true,
      type: Boolean
    },
    showOnlyOwnerAuthority: {
      required: true,
      type: Boolean
    },
    showMoreThanOperatorAuthority: {
      required: true,
      type: Boolean
    },
    currentUser: {
      required: true,
      type: Object
    },
    hasAvailableProduct: {
      required: true,
      type: Boolean
    },
  },
  computed: {
    ...mapState({
      isGlobalMenu: state => state.layout.isGlobalMenu,
      showMenuName: state => state.menu.showMenuName,
      hoverMenu: state => state.hoverMenu,
      companiesAvailableSites: state => state.companiesAvailableSites.data,
    }),
    ...piniaMapState(
      useRpaErrorLogsStore, ['rpaErrorLogs', 'rpaErrorLogsLoading']
    ),
    ...mapGetters({
      unreadObservationCount: 'companiesUserActivity/unreadObservationCount',
      unreadReviewsCount: 'companiesUserActivity/unreadReviewsCount',
      unreadPhotosCount: 'companiesUserActivity/unreadPhotosCount',
      unreadSurveyAnswersCount: 'companiesUserActivity/unreadSurveyAnswersCount',
      unreadGmbLocationSyncLogsCount: 'companiesUserActivity/unreadGmbLocationSyncLogsCount',
      canModifyServiceList: 'companiesCompany/canModifyServiceList',
      canHaveFoodMenus: 'companiesCompany/canHaveFoodMenus',
      providedFeaturesMediaLibrary: 'companiesCompany/providedFeaturesMediaLibrary',
      providedFeaturesFoodMenu: 'companiesCompany/providedFeaturesFoodMenu',
      providedFeaturesServicePattern: 'companiesCompany/providedFeaturesServicePattern',
      providedFeaturesProduct: 'companiesCompany/providedFeaturesProduct',
      providedFeaturesReview: 'companiesCompany/providedFeaturesReview',
      providedFeaturesPhoto: 'companiesCompany/providedFeaturesPhoto',
      providedFeaturesSurvey: 'companiesCompany/providedFeaturesSurvey',
      providedFeaturesTestimonial: 'companiesCompany/providedFeaturesTestimonial',
      providedFeaturesPost: 'companiesCompany/providedFeaturesPost',
      providedFeaturesSns: 'companiesCompany/providedFeaturesSns',
      providedFeaturesAnalysisInsight: 'companiesCompany/providedFeaturesAnalysisInsight',
      providedFeaturesAnalysisReview: 'companiesCompany/providedFeaturesAnalysisReview',
      providedFeaturesAnalysisScatter: 'companiesCompany/providedFeaturesAnalysisScatter',
      providedFeaturesAnalysisRanking: 'companiesCompany/providedFeaturesAnalysisRanking',
      providedFeaturesAnalysisQsca: 'companiesCompany/providedFeaturesAnalysisQsca',
      providedFeaturesAnalysisVisitor: 'companiesCompany/providedFeaturesAnalysisVisitor',
      providedFeaturesAnalysisKeyword: 'companiesCompany/providedFeaturesAnalysisKeyword',
      providedFeaturesAnalysisSurvey: 'companiesCompany/providedFeaturesAnalysisSurvey',
      providedFeaturesAnalysisSearchKeywordImpression: 'companiesCompany/providedFeaturesAnalysisSearchKeywordImpression',
      providedFeaturesCompetitor: 'companiesCompany/providedFeaturesCompetitor',
      providedFeaturesVisitor: 'companiesCompany/providedFeaturesVisitor',
      providedFeaturesBenefit: 'companiesCompany/providedFeaturesBenefit',
      isDocomoPlan: 'companiesCompany/isDocomoPlan',
      isRettyPlan: 'companiesCompany/isRettyPlan',
      useServiceName: 'companiesCompany/useServiceName',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentMenu() {
      const path = this.$route.path.toString().split(`${this.$route.params.company_uuid}/`)
      return path[1]
    },
    analysisTypes() {
      return reviewDataTypes.map(v => {
        v.routerLocationObj = { name: 'CompaniesAnalysisReviews', query: { type: v.id } }
        return v
      })
    },
    gmbPosts() {
      return [
        {
          id: 'CompaniesStorePostsIndex',
          name: this.$t('layouts.sideMenu.operation.gmbPosts.index'),
          routerLocationObj: { name: 'CompaniesStorePostsIndex' }
        },
        {
          id: 'CompaniesStorePostsNew',
          name: this.$t('layouts.sideMenu.operation.gmbPosts.new'),
          routerLocationObj: { name: 'CompaniesStorePostsNew' }
        },
      ]
    },
    snsPosts() {
      return [
        {
          id: 'CompaniesStoreSnsPostsIndex',
          name: this.$t('layouts.sideMenu.operation.snsPosts.index'),
          routerLocationObj: { name: 'CompaniesStoreSnsPostsIndex' }
        },
        {
          id: 'CompaniesStoreSnsPostsNew',
          name: this.$t('layouts.sideMenu.operation.snsPosts.new'),
          routerLocationObj: { name: 'CompaniesStoreSnsPostsNew' }
        },
      ]
    },
    gmbInsightDataTypes() {
      const arr = []
      gmbInsightDataTypes.forEach(type => {
        arr.push({
          name: type.name,
          disabled: true
        })
        type.data.forEach(v => {
          arr.push({
            name: v.name,
            disabled: false,
            routerLocationObj: { name: 'CompaniesAnalysisInsight', query: { type: v.id } }
          })
        })
      })
      return arr
    },
    keywordAnalysisTypes() {
      return keywordAnalysisTypes.map(v => {
        v.routerLocationObj = { name: 'CompaniesAnalysisKeywords', query: { tab: v.id } }
        return v
      })
    },
    visitorsTypes() {
      const availableVisitorsTypesIds = ['lpPvs', 'likeCount', 'dislikeCount', 'surveyAnswerCount']
      if (this.companiesAvailableSites) {
        availableVisitorsTypesIds.push(
          ...this.companiesAvailableSites.map(site => {
            return `${camelCase(site.attributes.site_type)}ImpressionCount`
          })
        )
      }
      return visitorsTypes.filter(vt => availableVisitorsTypesIds.includes(vt.id)).map(v => {
        v.routerLocationObj = { name: 'CompaniesAnalysisVisitors', query: { type: v.dataType } }
        return v
      })
    },
    hasSites() {
      return this.companiesAvailableSites && this.companiesAvailableSites.length > 0
    },
    locationStore() {
      const results = [
        {
          id: 'CompaniesLocationStores',
          name: this.$t('layouts.sideMenu.locationStore.stores.index'),
          routerLocationObj: { name: 'CompaniesLocationStores' }
        }
      ]

      if (this.showOnlyOwnerAuthority && !this.isDocomoPlan) {
        results.push(
          {
            id: 'CompaniesLocationStoreNew',
            name: this.$t('layouts.sideMenu.locationStore.stores.new'),
            routerLocationObj: { name: 'CompaniesLocationStoreNew' }
          }
        )
      }

      if(!this.isDocomoPlan && !this.isRettyPlan) {
        results.push({
          id: 'CompaniesGMBLocationSyncLogs',
          name: this.$t('layouts.sideMenu.locationStore.stores.logs'),
          routerLocationObj: { name: 'CompaniesGMBLocationSyncLogs' },
          unreadCount: this.unreadGmbLocationSyncLogsCount
        })
      }

      if (this.hasSites) {
        results.push({
          id: 'CompaniesRpaErrorLogs',
          name: this.$t('layouts.sideMenu.locationStore.stores.rpaErrorLogs'),
          routerLocationObj: { name: 'CompaniesRpaErrorLogs' },
          unreadCount: this.rpaErrorLogs.length
        })
      }

      return results
    },
    products() {
      return [
        {
          id: 'CompanyLocationProducts',
          name: this.$t('layouts.sideMenu.locationStore.products.index'),
          routerLocationObj: { name: 'CompaniesProducts' }
        },
        {
          id: 'CompanyLocationProductNew',
          name: this.$t('layouts.sideMenu.locationStore.products.new'),
          routerLocationObj: { name: 'CompaniesProductNew' }
        }
      ]
    },
    hasMonitoringFeatures() {
      return this.providedFeaturesReview || this.providedFeaturesPhoto
        || this.providedFeaturesSurvey || this.providedFeaturesTestimonial
    },
    hasOperationFeatures() {
      return this.providedFeaturesPost
    },
    hasAnalysisFeatures() {
      return this.providedFeaturesAnalysisInsight
        || this.providedFeaturesAnalysisReview
        || this.providedFeaturesAnalysisScatter
        || this.providedFeaturesAnalysisRanking
        || this.providedFeaturesAnalysisQsca
        || this.providedFeaturesAnalysisVisitor
        || this.providedFeaturesAnalysisKeyword
        || this.providedFeaturesAnalysisSurvey
    },
    hasCompetitorFeatures() {
      return this.providedFeaturesCompetitor
        && (this.providedFeaturesReview
          || this.providedFeaturesPhoto
          || this.providedFeaturesAnalysisReview
          || this.providedFeaturesAnalysisKeyword)
    },
    hasVisitorFeatures() {
      return this.providedFeaturesVisitor || this.providedFeaturesSurvey
    },
    logoName() {
      switch(this.useServiceName) {
      case 'kcom':
        return 'logoBlack'
      case 'localone':
        return 'logoLocalOne'
      case 'retty':
        return 'logoRetty'
      default:
        return ''
      }
    }
  },
  created() {
    this.initMenu(this.currentMenu)
    this.readRpaErrorLogs(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      toggleGlobalMenu: 'layout/toggleGlobalMenu',
      toggleHoverMenu: 'hoverMenu/toggleHoverMenu',
      toggleMenu: 'menu/toggleMenu',
      initMenu: 'menu/initMenu'
    }),
    ...piniaMapActions(useRpaErrorLogsStore, ['readRpaErrorLogs']),
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      requestAnimationFrame(() => {
        el.style.height = el.scrollHeight + 'px'
      })
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      requestAnimationFrame(() => {
        el.style.height = '0'
      })
    },
    hoverMenuPosition(name) {
      return this.$refs[name] ? this.$refs[name].getBoundingClientRect().top : 0
    }
  },
}
</script>

<style lang="scss" scoped>
.logoIcon {
  width: 100px;
}
// 以下のclassは再びメニューを常時閉じる時のために残しておく。
.menu-enter-active {
  animation-duration: .3s;
  animation-fill-mode: both;
  animation-name: js-accordion--anime__opened;
}
.menu-leave-active {
  animation-duration: 0s;
  animation-fill-mode: both;
  animation-name: js-accordion--anime__closed;
}
@keyframes js-accordion--anime__opened {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes js-accordion--anime__closed {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
